export default "__VITE_ASSET__P7defm5O__"